/**
 * Returns true if section matches window.currentSection
 * 
 * @export
 * @param {string} section 
 * @returns {boolean} 
 */
declare global {
    interface Window { loadModule: string; }
}

export function isTargetModule(section: string): boolean {
    return (window.loadModule === section || section === '*');
}